import React from "react";
import "./wcu.css";
import img1 from "../Assets/wcu1.png";
import img2 from "../Assets/wcu2.png";
import img3 from "../Assets/wcu3.png";
const data = [
  {
    title: "State Of The Art Facilities",
    content:
      "Modern infrastructure designed to support advanced diagnosis and treatments.",
  },
  {
    title: "Patient-Centered Approach",
    content: "Treatment plans focused on your unique health needs and comfort.",
  },
  {
    title: "Holistic Care",
    content:
      "Emphasis on preventive health, rehabilitation, and long-term wellness.",
  },
  {
    title: "Rehabilitation & Support Services",
    content: "Post-treatment care designed for optimal recovery.",
  },
];
function WhyChooseUs() {
  return (
    <div className="wcu-container">
      <h2>Why Choose Us</h2>
      <p>
        Our commitment to continuous improvement ensures that we stay at the
        forefront of medical innovation, offering our patients the best care
        possible.
      </p>
      <div className="wcu-content">
        <div className="left-content">
          {data.map((ele, ind) => (
            <>
              <div className="ele-title">{ele.title}</div>
              <div className="ele-content">{ele.content}</div>
            </>
          ))}
        </div>
        <div className="right-content">
          <img src={img1} alt="" />
          <img src={img2} alt="" />
          <img src={img3} alt="" className="full-width" />
        </div>
      </div>
    </div>
  );
}

export default WhyChooseUs;
